
import { useMemo } from 'react'
import { generateColorDictionary } from "../utils";
export default function AttackSimulator({ attack, language, onSimulate }){
  const bg = useMemo(()=>{
    if(!attack) return '#fff'
    // very light tint based on attack color
    const c = attack.color.replace('#','')
    const r = parseInt(c.substring(0,2),16)+160
    const g = parseInt(c.substring(2,4),16)+160
    const b = parseInt(c.substring(4,6),16)+160
    const clamp = v=>Math.max(0,Math.min(255,v))
    return `rgb(${clamp(r)}, ${clamp(g)}, ${clamp(b)})`

    
  }, [attack])
  
  const syn = useMemo(() => generateColorDictionary(), [attack, language]);

  const previewText = useMemo(() => {

    const t = attack?.example || "Coloranti123";

    return String(t).replace(/[^a-zA-Z0-9]/g, "");
  }, [attack]);

  const previewColors = useMemo(() => {
    if (!attack) return Array(8).fill("#eceff3");

    const chars = previewText.length ? previewText : "Coloranti123";
    const colors = [];

    for (const ch of chars) {
      const tuple = syn[ch];
      if (tuple) colors.push(`rgb${tuple}`);
      if (colors.length === 8) break;
    }
    while (colors.length < 8) colors.push("#eceff3");
    return colors;
  }, [attack, previewText, syn]);


  return (
    <div className="lang-card" style={{ background:bg }}>
      <div className="lang-row">
     <div><strong>Simulated Attack:</strong> {attack ? `${attack.name} — ${attack.example}` : '—'}</div>
        <div><strong>Assigned Language:</strong> {language || '—'}</div>
      </div>
{/*       
      <div className="preview" aria-hidden="true">
        {[...Array(8)].map((_,i)=>(
          <div className="color-block" key={i} style={{ background: attack ? attack.color : '#eceff3' }} />
        ))}
      </div> */}

     <div className="preview" aria-hidden="true">
        {previewColors.map((color, i) => (
          <div className="color-block" key={i} style={{ background: color }} />
        ))}
      </div>

      <div className="lang-row">
        <button className="btn" onClick={onSimulate}>Simulate Attack</button>
      </div>
        <p style={{color:'#667',marginTop:8}}>Only one language is shown at a time. Languages are randomly assigned together with an attack when you press <strong>Simulate Attack</strong>.</p>
      {/* <p style={{color:'#667',marginTop:8}}>Background and text colors change to reflect the chosen attack color. Background stays light for readability.</p> */}
    </div>
  )
}
